import XLSX from 'xlsx';

export default function exportToSheet(
  dataJSON: any[],
  nomeArquivo: string,
  cabecalhoOrdenado = true,
  colunasMoeda: string[] = [],
): void {
  const fileName = `${nomeArquivo}_${new Intl.DateTimeFormat('pt-BR').format(
    new Date(),
  )}.xlsx`;

  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataJSON);

  if (cabecalhoOrdenado && ws['!ref']) {
    ws['!autofilter'] = {
      ref: ws['!ref'],
    };
  }

  const range = ws['!ref'] ? XLSX.utils.decode_range(ws['!ref']) : null;

  if (range && dataJSON.length > 0) {
    const colunas = Object.keys(dataJSON[0]);

    const colunasPlanilha = ws['!cols'] ?? [];
    ws['!cols'] = colunasPlanilha;

    colunasMoeda.forEach(coluna => {
      const colunaIndex = colunas.indexOf(coluna);

      if (colunaIndex === -1) {
        return;
      }

      let maiorLargura = coluna.length;

      // eslint-disable-next-line no-plusplus
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({
          r: row,
          c: colunaIndex,
        });

        const cell = ws[cellAddress];

        if (cell && typeof cell.v === 'number') {
          cell.z = 'R$ #,##0.00';

          const valorFormatado = `R$ ${cell.v.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;

          maiorLargura = Math.max(maiorLargura, valorFormatado.length);
        }
      }

      colunasPlanilha[colunaIndex] = {
        wch: maiorLargura + 2,
      };
    });
  }

  const wb: XLSX.WorkBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, nomeArquivo.substring(0, 31));

  XLSX.writeFile(wb, fileName);
}
